import { ProjectCardDataProps } from "components/molecules/ProjectCard/types";

const projects: ProjectCardDataProps[] = [
  {
    title: 'codeWinter - An AI‑powered PRD generator for users coding agents [Contributed]',
    description: 'AI‑assisted Product Requirements for users feature graph. codeWinter turns a project’s feature list into a dependency graph and generates consistent, professional PRDs per feature.',
    stack: 'Next.js,TypeScript, TailwindCSS, Zustland, Supabase, React Flow, Gemini AI, zod, react-markdown, remark-gfm, Bun',
    type: 'github',
    url: 'https://github.com/jamiul-islam/codeWinter',
  },
  {
    title: 'Taskflow - A Task Management Dashboard',
    description: 'Taskflow a powerful task management dashboard that is intended to boost productivity and job monitoring. It has strong user authentication, including Google Sign-In, as well as an easy-to-use task management system.',
    stack: 'React,TailwindCSS, Firebase, Context API, Express.js, MongoDB',
    type: 'github',
    url: 'https://github.com/farhanshahriyar/taskflow-client',
  },
  {
    title: 'BazarBuddy - A Grocery Management WebApp',
    description: 'BazarBuddy is a smart, modern web application designed to revolutionize the way families manage groceries. It offers powerful features like collaborative shopping lists, real-time expense tracking, and AI-powered item suggestions — all wrapped in a clean, responsive interface.',
    stack: 'React, ShadCN UI, React Hook Form + Zod, Supabase',
    type: 'github',
    url: 'https://github.com/farhanshahriyar/BazarBuddy-Family-Grocery-Management-App',
  },
  {
    title: 'KingsRock eSports Webportal',
    description: 'A web application for managing KingsRock esports webportal - a sports platform features like member management, leave requests, tournaments, and attendance',
    stack: 'React, TypeScript, TailwindCSS, ShadCN/UI, Recharts, HeroIcons, Context API, Custom Hooks, Supabase',
    type: 'github',
    url: 'https://github.com/farhanshahriyar/KRWebPortal',
  },
  {
    title: 'VCT24 Ticket Event Website',
    description: 'The VCT24 Ticket Event Website is a platform where users can purchase tickets to a Valorant event by registering on the site. It features a seamless navigation header, a login mechanism powered by Firebase, and a visually appealing ticket purchasing section.',
    stack: 'React,TailwindCSS, Firebase',
    type: 'github',
    url: 'https://github.com/farhanshahriyar/vct24-ticket-event',
  },
  {
    title: 'Jobs - Find Your Dream Job',
    description:
      'Welcome to the repository for "Jobs," a comprehensive job-seeking platform that connects aspirants with their dream roles across various job types—On-Site, Remote, Hybrid, and Part-Time. This full-stack web application offers a seamless job listing and application experience, empowering users to post job openings, search for jobs, and manage their applications with ease.',
    stack: 'React,TailwindCSS, Firebase, Express, MongoDB',
    type: 'github',
    url: 'https://github.com/farhanshahriyar/jobs-client',
  },
  {
    title: 'Rezilla - Real Estate Platform',
    description: '"Rezilla" project involves the development of a Real Estate Platform using the MERN stack. The platform serves as an online space where users can add and buy real estate properties.',
    stack: 'React,TailwindCSS, Firebase, Express, MongoDB',
    type: 'github',
    url: 'https://github.com/farhanshahriyar/rezilla-client',
  },
  {
    title: 'Dentist App',
    description: 'Dentist App is a website where people can see the services of a dentist.',
    stack: 'React,TailwindCSS, Firebase, Express, MongoDB',
    type: 'github',
    url: 'https://github.com/farhanshahriyar/dentistApp',
  },
  {
    title: 'Movie Network',
    description: 'Movie Network" to give movie fans smooth, ad-free experiences through innovative web construction.',
    stack: 'React,Bootstrap, Firebase, Express, MongoDB',
    type: 'github',
    url: 'https://github.com/farhanshahriyar/MovieNetwork-frontend',
  },
  {
    title: 'BLDonor - Blood Donation Platform',
    description: 'Movie Network" to give movie fans smooth, ad-free experiences through innovative web construction.',
    stack: 'React,Bootstrap, Firebase, Express, MongoDB',
    type: 'github',
    url: 'https://github.com/farhanshahriyar/bldonorfrontend',
  },
];

export default projects;
